import { render, staticRenderFns } from "./CarteiraCliente.vue?vue&type=template&id=715e164b&"
import script from "./CarteiraCliente.vue?vue&type=script&lang=js&"
export * from "./CarteiraCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/carteira-cliente/CarteiraCliente.vue
// module id = 1083
// module chunks = 28